define([
	"dojo/_base/declare",
	"csi/heading/AttributeController",
	"csi/widget/MessageDialog"
], function(declare,AttributeController,MessageDialog) {

	return declare(AttributeController, {
		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_RESET) {
				this.newValue = "";
				this.process();
			} else {
				this.postProcess();
			}
		}
	});
});